import { defaultPersonNameConfig } from '@vista/i18n';
import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccPersonNameConfig = Object.assign(Object.assign({}, defaultPersonNameConfig), { listSeparator: ', ' });
export const occPersonNameConfigValidator = Validator.object({
    formats: Validator.array({ minLength: 1, items: nonEmptyStringValidator }),
    listSeparator: nonEmptyStringValidator
});
